import React, { useRef, useState, useEffect } from 'react';
import './video-block.scss';

const VideoBlock = ({
    portrayalText,
    ariaLabel,
    maxHeight,
    minHeight,
    videoSrc,
    posterThumbnail,
    videoBtn,
    gradient,
    customGradientClass = ''
}

) => {
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [announcement, setAnnouncement] = useState('');

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        const handlePlay = () => setIsPlaying(true);
        const handlePause = () => setIsPlaying(false);

        video.addEventListener('play', handlePlay);
        video.addEventListener('pause', handlePause);

        // Check initial state after mount
        if (!video.paused) {
            setIsPlaying(true);
        }

        return () => {
            video.removeEventListener('play', handlePlay);
            video.removeEventListener('pause', handlePause);
        };
    }, []);

    const togglePlay = (e) => {
        e.preventDefault();
        if (isPlaying) {
            videoRef.current.pause();
            setAnnouncement('Video paused');
        } else {
            videoRef.current.play();
            setAnnouncement('Video playing');
        }
    };

    return (
        <div className={`block-video-wrapper ${customGradientClass} ${gradient ? 'gradient' : ''}`} style={{ maxHeight: maxHeight }}>
            <div className={``}>
                <video
                    ref={videoRef}
                    src={videoSrc}
                    poster={posterThumbnail}
                    autoPlay
                    loop
                    muted
                    style={{ minHeight: minHeight }}
                    playsInline
                    aria-hidden
                    tabIndex={"-1"}
                />

            </div>
            {portrayalText &&
                <div className="actor-portrayals" aria-hidden>
                    <span>{portrayalText}</span>
                </div>
            }
            {videoBtn === true &&
                <>
                <span className="sr-only" aria-live="polite">{announcement}</span>
                <button className="video-btn" onClick={togglePlay} aria-label={isPlaying ? `Pause ${ariaLabel}` : `Play ${ariaLabel}`}>
                    {isPlaying ? (
                        <svg width="16" height="26" viewBox="0 0 16 26" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
                            <rect width="2.66667" height="26" fill="white" />
                            <rect x="13.3333" width="2.66667" height="26" fill="white" />
                        </svg>
                    ) : (
                        <svg className='pause-icon' width="16" height="26" viewBox="0 0 16 26" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 0L16 13L0 26V0Z" fill="white" />
                        </svg>
                    )}
                </button>
                </>
            }
        </div>
    );
};

export default VideoBlock;
